(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this._slides   = [...this.querySelectorAll('.hs-slide')];
      this._track    = this.querySelector('.hs-track');
      this._dots     = [...this.querySelectorAll('.hs-dot')];
      this._counter  = this.querySelector('.hs-counter__current');
      this._current  = 0;
      this._timer    = null;
      this._autoplay = this.dataset.autoplay === 'true';
      this._speed    = parseInt(this.dataset.speed) || 4000;

      if (!this._track || this._slides.length === 0) return;

      this._bindEvents();
      if (this._autoplay && this._slides.length > 1) this._startAutoplay();
    }

    _goTo(index) {
      if (this._slides.length <= 1) return;

      const prev    = this._current;
      this._current = ((index % this._slides.length) + this._slides.length) % this._slides.length;
      if (prev === this._current) return;

      this._slides[prev].classList.remove('hs-slide--active');
      this._slides[prev].setAttribute('aria-hidden', 'true');

      this._slides[this._current].classList.add('hs-slide--active');
      this._slides[this._current].setAttribute('aria-hidden', 'false');

      if (this._dots[prev]) {
        this._dots[prev].classList.remove('hs-dot--active');
        this._dots[prev].setAttribute('aria-selected', 'false');
      }
      if (this._dots[this._current]) {
        this._dots[this._current].classList.add('hs-dot--active');
        this._dots[this._current].setAttribute('aria-selected', 'true');
      }

      if (this._counter) this._counter.textContent = this._current + 1;

      this._slides.forEach((slide, i) => {
        slide.querySelectorAll('video').forEach(v => {
          if (i === this._current) { v.play().catch(() => {}); }
          else { v.pause(); }
        });
      });
    }

    _next() { this._goTo(this._current + 1); }
    _prev() { this._goTo(this._current - 1); }

    _startAutoplay() {
      this._stopAutoplay();
      this._timer = setInterval(() => this._next(), this._speed);
    }

    _stopAutoplay() { clearInterval(this._timer); }

    _bindEvents() {
      const btnPrev = this.querySelector('.hs-arrow--prev');
      const btnNext = this.querySelector('.hs-arrow--next');

      const navigate = (fn) => () => {
        this._stopAutoplay();
        fn.call(this);
        if (this._autoplay) this._startAutoplay();
      };

      if (btnPrev) btnPrev.addEventListener('click', navigate(this._prev));
      if (btnNext) btnNext.addEventListener('click', navigate(this._next));

      this._dots.forEach(dot => {
        dot.addEventListener('click', navigate(() => {
          this._goTo(parseInt(dot.dataset.index));
        }));
      });

      /* Swipe */
      let startX = 0;
      this.addEventListener('touchstart', e => {
        startX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', e => {
        const delta = startX - e.changedTouches[0].screenX;
        if (Math.abs(delta) > 48) navigate(delta > 0 ? this._next : this._prev)();
      }, { passive: true });

      /* Pause on hover */
      if (this._autoplay) {
        this.addEventListener('mouseenter', () => this._stopAutoplay());
        this.addEventListener('mouseleave', () => this._startAutoplay());
      }

      /* Pause when tab is hidden */
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { this._stopAutoplay(); }
        else if (this._autoplay) { this._startAutoplay(); }
      });
    }
  }

  if (!customElements.get('hero-slideshow-component')) {
    customElements.define('hero-slideshow-component', HeroSlideshow);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const el = event.target.querySelector('hero-slideshow-component');
    if (el) { el._initialized = false; el.connectedCallback(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonialsCarousel(root) {
      if (!root || root.dataset.testimonialsInitialized === 'true') return;
      root.dataset.testimonialsInitialized = 'true';

      var carousel = root.querySelector('[data-testimonials-carousel]');
      var track = root.querySelector('[data-testimonials-track]');
      var dotsWrap = root.querySelector('[data-testimonials-dots]');
      if (!carousel || !track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-testimonials-slide]'));
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-testimonials-dot]')) : [];

      function updateDotsVisibility() {
        if (!dotsWrap) return;
        var isScrollable = carousel.scrollWidth > carousel.clientWidth + 1;
        dotsWrap.classList.toggle('is-active', isScrollable);
      }

      function setActiveDot(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }

      // Calcula qual slide está mais próximo da posição atual de scroll.
      // Mais confiável que IntersectionObserver quando vários cards estão
      // visíveis ao mesmo tempo (ex: desktop com 3 cards na tela).
      function getClosestSlideIndex() {
        var scrollLeft = carousel.scrollLeft;
        var closestIndex = 0;
        var closestDistance = Infinity;
        slides.forEach(function (slide, i) {
          var slideStart = slide.offsetLeft - track.offsetLeft;
          var distance = Math.abs(slideStart - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = i;
          }
        });
        return closestIndex;
      }

      var scrollRaf = null;
      function handleScroll() {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          setActiveDot(getClosestSlideIndex());
          scrollRaf = null;
        });
      }
      carousel.addEventListener('scroll', handleScroll, { passive: true });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.dataset.index, 10);
          var target = slides[index];
          if (target) {
            carousel.scrollTo({
              left: target.offsetLeft - track.offsetLeft,
              behavior: 'smooth'
            });
          }
        });
      });

      // Converte scroll vertical do mouse (wheel) em scroll horizontal
      carousel.addEventListener(
        'wheel',
        function (e) {
          if (carousel.scrollWidth <= carousel.clientWidth) return;
          if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
          e.preventDefault();
          carousel.scrollLeft += e.deltaY;
        },
        { passive: false }
      );

      // Arrastar com o mouse (click and drag) para navegar
      var isDragging = false;
      var dragStartX = 0;
      var dragStartScrollLeft = 0;
      var dragMoved = false;

      carousel.addEventListener('mousedown', function (e) {
        isDragging = true;
        dragMoved = false;
        carousel.classList.add('is-dragging');
        dragStartX = e.pageX - carousel.offsetLeft;
        dragStartScrollLeft = carousel.scrollLeft;
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        e.preventDefault();
        var x = e.pageX - carousel.offsetLeft;
        var walk = x - dragStartX;
        if (Math.abs(walk) > 5) dragMoved = true;
        carousel.scrollLeft = dragStartScrollLeft - walk;
      });

      function stopDragging() {
        if (!isDragging) return;
        isDragging = false;
        carousel.classList.remove('is-dragging');
      }
      window.addEventListener('mouseup', stopDragging);
      carousel.addEventListener('mouseleave', stopDragging);

      // Evita que o "arrastar" seja interpretado como clique acidental
      carousel.addEventListener(
        'click',
        function (e) {
          if (dragMoved) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      updateDotsVisibility();
      setActiveDot(getClosestSlideIndex());

      var resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
          updateDotsVisibility();
          setActiveDot(getClosestSlideIndex());
        }, 150);
      });
    }

    function initAll() {
      document.querySelectorAll('.testimonials-section').forEach(initTestimonialsCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Reinicializa quando a seção é recarregada no editor de temas (Shopify Theme Editor)
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.testimonials-section');
      if (root) {
        root.dataset.testimonialsInitialized = 'false';
        initTestimonialsCarousel(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
